import { getEntry, saveEntry } from './storage';
import { journalPhotoUploadDirect } from './cloudApi';
import { compressImageToJpeg } from './journalPhotoPicker';

const blobToBase64 = (blob) =>
  new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onloadend = () => {
      const s = String(r.result || '');
      const i = s.indexOf(',');
      resolve(i >= 0 ? s.slice(i + 1) : s);
    };
    r.onerror = () => reject(new Error('Could not read image'));
    r.readAsDataURL(blob);
  });

/** Compress, upload JPEG to GCS via Cloud Run (no client-side signed URL / IAM signBlob), merge into local entry. */
export async function uploadJournalPhotoForDate(dateStr, rawBlob) {
  const entryId = String(dateStr || '').trim();
  if (!entryId) throw new Error('Missing entry date');

  const jpeg = await compressImageToJpeg(rawBlob, 1600, 0.85);
  const imageBase64 = await blobToBase64(jpeg);
  const done = await journalPhotoUploadDirect({ entryId, imageBase64 });

  const prev = getEntry(entryId) || {};
  const prevAtt = Array.isArray(prev.attachments) ? prev.attachments : [];
  const next = [...prevAtt, done.attachment].filter(Boolean);
  saveEntry(entryId, { ...prev, attachments: next });
  return { attachment: done.attachment, attachments: next };
}
